import { PositionAssignmentRequest } from '@src/main/modules/reports/shared/domain/report.interface';
import { format } from 'date-fns';

export function parsePositionAssignmentCriteria(
  criteria: PositionAssignmentRequest,
): Record<string, string | number> {
  const sortFieldMap: Record<string, string> = {
    flightNumber: 'flight_num',
    flightDate: 'flight_date',
    departureAirport: 'flight_departure',
    arrivalAirport: 'flight_arrival',
    aircraftRegistration: 'flight_mat',
  };

  const params: Record<string, string | number> = {};

  if (criteria.offset !== null) {
    params.offset = Number(criteria.offset);
  }

  if (criteria.limit !== null) {
    params.limit = Number(criteria.limit);
  }

  if (criteria.sortField !== null) {
    params.sortField = sortFieldMap[criteria.sortField] ?? criteria.sortField;
  }

  if (criteria.sortOrder !== null) {
    params.sortOrder = criteria.sortOrder;
  }

  if (criteria.flightNumber !== null) {
    params.flight_num = criteria.flightNumber;
  }

  if (criteria.flightDate !== null) {
    params.flight_date = criteria.flightDate;
  }

  if (criteria.departureAirport !== null) {
    params.flight_departure = criteria.departureAirport;
  }

  if (criteria.arrivalAirport !== null) {
    params.flight_arrival = criteria.arrivalAirport;
  }

  if (criteria.aircraftRegistration !== null) {
    params.flight_mat = criteria.aircraftRegistration;
  }

  if (criteria.purserEmployeeId !== null) {
    params.purserEmployeeId = criteria.purserEmployeeId;
  }

  if (criteria.flightSince !== null) {
    params.flightSince = format(new Date(criteria.flightSince), 'yyyy-MM-dd');
  }

  if (criteria.flightUntil !== null) {
    params.flightUntil = format(new Date(criteria.flightUntil), 'yyyy-MM-dd');
  }

  return params;
}
